<template>
    <div class="shadow-sm vizzibuzz_sidebar">
      <b-navbar  type="dark" variant="info">
        <b-navbar-brand href="javascript:void(0)" @click="toggleSidebar">
          <i class="fa fa-outdent mr-3 my-3" aria-hidden="true" v-b-toggle.sidebar-1></i>
          <img src="../../assets/img/vizibuzz_logo.png" class="img-fluid" v-if="isVizibuzz"/>
          <img src="../../assets/img/fplmis/logo2.png" class="img-fluid" style="width:auto !important;" v-else/>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse">

        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <!-- <b-nav-item v-if="isVizibuzz"><h5 style="color:#4c4c4c">Dashboard</h5></b-nav-item> -->
            <b-nav-item v-if="!isVizibuzz"><h5 style="color:#4c4c4c">FPSS Dashboard</h5></b-nav-item>
            <!-- <b-nav-item href="#" disabled>Disabled</b-nav-item>-->
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- <b-nav-item href="#">Contact</b-nav-item>
            <b-nav-item href="#" class="mr-5">Help</b-nav-item> -->

            <div class="d-flex corner_icon">
              <b-nav-item href="#" class="align-items-center d-flex justify-center" disabled><img src="../../assets/img/trans_icon.png" class="img-fluid"></b-nav-item>
              <b-nav-item href="#" class="align-items-center d-flex justify-center" disabled><img src="../../assets/img/lang_icon.png" class="img-fluid"></b-nav-item>
              <b-nav-item href="#" class="align-items-center d-flex justify-center" disabled><img src="../../assets/img/mail_icon.png" class="img-fluid"></b-nav-item>
              <!-- <b-nav-item href="#" class="align-items-center d-flex justify-center"><i class="fa fa-user navIconUser" aria-hidden="true" ></i></b-nav-item>
              <b-nav-item href="#" class="align-items-center d-flex justify-center" @click="logout"><i class="fa fa-sign-out navIconUser" aria-hidden="true" ></i></b-nav-item> -->
               <b-nav-item-dropdown split class="align-items-center d-flex justify-center">
                <span slot="text"><i class="fa fa-user navIconUser"></i></span>
                <b-dropdown-item href="#/profile" class="text-dark">My Profile</b-dropdown-item>
                <b-dropdown-item href="#/changePassword" class="text-dark">Change Password</b-dropdown-item>
                <b-dropdown-item href="#" @click="logout" class="text-dark">Logout</b-dropdown-item>
              </b-nav-item-dropdown>
            </div>

          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
       <!-- <b-sidebar id="sidebar-1" title="Sidebar" shadow>
         <nav class="navbar navbar-expand navbar-dark bg-dark flex-md-column flex-row align-items-start">
                <div class="collapse navbar-collapse">
                    <ul class="flex-md-column flex-row navbar-nav w-100 justify-content-between">
                        <li class="nav-item">
                            <a class="nav-link pl-0" href="#"> <i class="fa fa-file-text-o text-white" aria-hidden="true"></i> Applications</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link pl-0" href="#"> <i class="fa fa-sign-out text-white" aria-hidden="true"></i> Request Access</a>
                        </li>
                        ..
                    </ul>
                </div>
            </nav>
      </b-sidebar> -->
    </div>

</template>
<script>
import ApiServices from '../../service/ApiServices';
export default {
  data(){
    return{
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      settings: settings,
      isVizibuzz: true
    }
  },
  methods:{
    toggleSidebar() {
      this.$emit('toggleSidebar')
    },
    copyToClipboard(e){
      //console.log(e.target.getAttribute('data-link'));
      var dummy = document.createElement('input'),
      text = e.target.getAttribute('data-link');
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
    logout(){
      //dhis-web-commons-security/logout.action
      ApiServices.RestGetCall('dhis-web-commons-security/logout.action',{}).then(res=>{
        // console.log("res",res);
        localStorage.removeItem("userProfile");
        localStorage.removeItem("loggedInUserId");
        this.$router.push("/");
      })
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
    }
  },
  mounted(){
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl+this.dashboardUrl;
    if(settings.countryName) {
      this.isVizibuzz = false
    }
    //console.log(this.dashboardUrl)
  }
}
</script>
<style lang="scss" scoped>
.corner_icon img {
    width: 68%;
    display: block;
    margin-top: 10px;
    margin: 0px auto;
}
.navIconUser{
    font-size: 18px;
}
.fa{
  color: #4c4c4c;
}

</style>
